import script from "./OrderHistoryPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistoryPanel.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistoryPanel.vue?vue&type=style&index=0&id=1a1df854&lang=scss"

const __exports__ = script;

export default __exports__